import React, { FC } from 'react'

import styled from 'styled-components'

import SecureIcon from 'src/Assets/Svg/pages-icons/Secure.svg?react'
import {
  CampaignPlatformTypeEnum,
  SpotifyCampaignMatchingType,
} from 'src/Types/campaigns'

const StyledSecureIcon = styled(SecureIcon)`
  color: ${({ theme }) => theme.color.darkGrey};
`

const ProtectedContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  background: ${({ theme }) => theme.color.white};
`
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`

const TextTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

const Text = styled(TextTitle)`
  font-weight: 400;
`

const META_PROTECTION_TEXT =
  '100% budget efficiency. Every dollar goes directly to targeted Instagram ads with real-time performance tracking.'

const protectionTextMap: Partial<Record<CampaignPlatformTypeEnum, string>> = {
  [CampaignPlatformTypeEnum.SPOTIFY]:
    "100% genuine reviews. If curators don't review your track within 14 days, your budget is credited back.",
  [CampaignPlatformTypeEnum.TIKTOK]:
    "100% view coverage. If creators don't deliver your target views within the campaign, your budget is credited back.",
  [CampaignPlatformTypeEnum.META]: META_PROTECTION_TEXT,
}

const SPOTIFY_MANUAL_MATCHING_TEXT =
  "100% genuine reviews. If curators don't review your track within 7 days, your budget is credited back."

interface Props {
  platform: CampaignPlatformTypeEnum
  matchingType?: SpotifyCampaignMatchingType | null
}

const getProtectionText = (
  platform: CampaignPlatformTypeEnum,
  matchingType?: SpotifyCampaignMatchingType | null,
): string | undefined => {
  if (
    platform === CampaignPlatformTypeEnum.SPOTIFY &&
    matchingType === SpotifyCampaignMatchingType.MANUAL
  ) {
    return SPOTIFY_MANUAL_MATCHING_TEXT
  }

  return protectionTextMap[platform]
}

export const ArtistProtectionProgram: FC<Props> = ({
  platform,
  matchingType,
}) => {
  const text = getProtectionText(platform, matchingType)

  if (!text) {
    return null
  }

  return (
    <ProtectedContainer>
      <StyledSecureIcon />
      <TextContainer>
        <TextTitle>Artist Protection Guarantee</TextTitle>
        <Text>{text}</Text>
      </TextContainer>
    </ProtectedContainer>
  )
}
